import { API } from '@aws-amplify/api'
import { Auth } from '@aws-amplify/auth'
import { AmplifyClass, Credentials, UniversalStorage } from '@aws-amplify/core'
import { Amplify } from '@aws-amplify/core'
import { DataStore } from '@aws-amplify/datastore'

import { getAmplifyConfig } from './config'

const requiredModules = [
  // API cannot function without Auth
  Auth,
  // Auth cannot function without Credentials
  Credentials,
]

// These modules have been tested with SSR
const defaultModules = [API, Auth, DataStore]

type Context = {
  req?: any
  modules?: any[]
}

export const withSSRContext = (context: Context = {}): AmplifyClass => {
  const { modules = defaultModules, req } = context
  let previousConfig = Amplify.configure()
  if (Object.keys(previousConfig).length === 0) {
    previousConfig = Amplify.configure(getAmplifyConfig())
  }

  const amplify = new AmplifyClass()
  const storage = new UniversalStorage({ req })

  requiredModules.forEach((m) => {
    if (!modules.includes(m)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore This expression is not constructable.
      // Type 'Function' has no construct signatures.ts(2351)
      amplify.register(new m.constructor())
    }
  })

  // Associate new module instances with this amplify
  modules.forEach((m) => {
    amplify.register(new m.constructor())
  })

  // Configure new Amplify instances with previous configuration
  amplify.configure({ ...previousConfig, storage })

  return amplify
}
